import { useEffect, useState, type FormEvent } from 'react';
import { ApiError } from '../lib/api';
import { useAuth } from '../lib/auth';

// Belépés a belépő-kóddal (egy felhasználó). Indító-szekvencia: a sorok egymás után jelennek meg; belépés előtt adatot nem mutat.
export function Login() {
  const { login } = useAuth();
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const [server, setServer] = useState<'…' | 'rendben' | 'nem elérhető'>('…');
  useEffect(() => { void fetch('/healthz', { cache: 'no-store' }).then((r) => setServer(r.ok ? 'rendben' : 'nem elérhető')).catch(() => setServer('nem elérhető')); }, []);
  const submit = async (e: FormEvent) => {
    e.preventDefault(); setBusy(true); setError('');
    try { await login(code); }
    catch (err) { setError(err instanceof ApiError && err.status === 401 ? 'Hibás kód. Próbáld újra.' : err instanceof ApiError && err.status === 429 ? 'Túl sok próbálkozás. Várj egy percet, aztán próbáld újra.' : 'A szerver nem válaszolt. Próbáld újra később.'); }
    finally { setBusy(false); }
  };
  const lines: [string, string][] = [['Kapcsolat a szerverrel', server], ['Felület betöltve', 'rendben'], ['Belépő-kód', busy ? 'ellenőrzés…' : 'vár']];
  return (
    <div className="a-login">
      <div className="a-bg" aria-hidden="true" />
      <form onSubmit={submit} className="a-login-card">
        <div className="a-login-brand"><span className="a-tiles big" aria-hidden="true"><i /><i /><i /><i /></span><span className="tw">AI Project Manager</span></div>
        <div className="a-boot a-stagger">{lines.map(([l, v], i) => <div key={l} style={{ ['--i' as string]: i * 3 }}><span>{l}</span><b className={v === 'nem elérhető' ? 'bad' : v === 'rendben' ? '' : 'wait'}>{v}</b></div>)}</div>
        <label htmlFor="code" className="a-kl" style={{ display: 'block', margin: '14px 0 6px' }}>Belépő-kód</label>
        <div className="a-codebox"><input id="code" type="password" autoFocus autoComplete="current-password" value={code} onChange={(e) => setCode(e.target.value)} className="a-input" />{!code && <span className="caret" aria-hidden="true" />}</div>
        {error && <p className="a-login-err" role="alert">{error}</p>}
        <button type="submit" disabled={busy || !code} className="a-btn pri wide" style={{ marginTop: 18 }}>{busy ? 'Belépés…' : 'Belépés'}</button>
        <p className="a-login-hint">Egy felhasználó, egy kód. A kódot a szerver beállításaiban cseréled.</p>
      </form>
    </div>
  );
}
